export default {
  FRONT_SEARCH_TAB_BUYING: 'front-search-tab-buying',
  FRONT_SEARCH_TAB_RENTING: 'front-search-tab-renting',
  FRONT_SEARCH_TAB_SELLING: 'front-search-tab-selling',
  FRONT_SEARCH_LOCATION_INPUT: 'front-search-location-input',
  FRONT_SEARCH_LOCATION_RESULTS: 'front-search-location-results',
  FRONT_SEARCH_AREA_INPUT: 'front-search-area-input',
  FRONT_SEARCH_PRICE_INPUT: 'front-search-price-input',
  FRONT_SEARCH_BUTTON: 'front-search-button',
  FILTER_ROOMS: 'filter-rooms',
  FILTER_CONDITION: 'condition',
  FILTER_PROPERTY_ID_INPUT: 'filter-property-id-input',

  NAVIGATION: {
    MAIN_NAV_LOGO: 'main-nav-logo',

    SELLING_LANDING_PAGE: 'top-navi-link-myymassa',
    RENTING_LANDING_PAGE: 'top-navi-link-vuokraamassa',
    BUYING_LANDING_PAGE: 'top-navi-link-ostamassa',
    SERVICES_LANDING_PAGE: 'top-navi-link-palvelut',

    BUYING: {
      APARTMENTS: 'sub-navi-link-myytavat-asunnot',
      NEW_HOUSING: 'sub-navi-link-myytavat-uudiskohteet',
      VACATION_HOUSING: 'sub-navi-link-myytavat-loma-asunnot',
      SITES: 'sub-navi-link-myytavat-tontit',
      FARMS: 'sub-navi-link-myytavat-maa-ja-metsatilat',
      OFFICES: 'sub-navi-link-myytavat-toimistot',
      GARAGES: 'sub-navi-link-myytavat-autotallit-ja-varastot',
      HOME_INSURANCE: 'sub-navi-link-kotivakuutus',
      CHANGE_APARTMENT_PAGE: 'sub-navi-link-asunnonvaihto',
      SALES_AND_MARKETING: 'sub-navi-link-asunnon-markkinointi',
      BUYING_REQUEST_TASK: 'sub-navi-link-ostotoimeksianto',
      SELL_NEW_APARTMENTS: 'sub-navi-link-uudiskohteiden-myynti',
      SELL_COTTAGE: 'sub-navi-link-loma-asunnon-myynti',
    },
    RENTING: {
      APARTMENTS: 'sub-navi-link-vuokrattavat-asunnot',
      VACATION_HOUSING: 'sub-navi-link-vuokrattavat-loma-asunnot',
      OFFICES: 'sub-navi-link-vuokrattavat-toimistot',
      GARAGES: 'sub-navi-link-vuokrattavat-autotallit-ja-varastot',
      RENTING_SECTION_PAGE: 'sub-navi-link-vuokraamassa-asuntosijoittaja',
    },
    SELLING: {
      HOW_WE_SELL: 'sub-navi-link-nain-myymme-asuntosi',
      AGENCIES: 'sub-navi-link-op-kiinteistonvalitys',
      PRICE_CALCULATOR: 'sub-navi-link-hintalaskuri',
      SELLER_SERVICE: 'sub-navi-link-myyjan-palvelu',
      ESTIMATE: 'sub-navi-link-laskuri',
      AID: 'sub-navi-link-valmistaudu',
      DIAS: 'sub-navi-link-digitaalinen-asuntokauppa',
      STYLING_SERVICES: 'sub-navi-link-stailauspalvelut',
    },
  },
};
